import { useMemo } from 'react';
import { Vehicle } from '@bringg/types';
import Driver from '../../../../stores/drivers/domain-object/driver';
import { useDeliveryBlocksStore } from '../../stores/delivery-blocks-root-store';

const useUnavailableResources = (
	drivers: Map<number, Driver>,
	vehicles: Map<number, Vehicle>,
	trailers: Map<number, Vehicle>,
	deliveryBlockTimeRange: { startTime: string; endTime: string },
	teamId,
	deliveryBlockId
) => {
	const { deliveryBlocksStore } = useDeliveryBlocksStore();

	const unavailableDriverIds = useMemo(() => {
		return new Set(
			[...drivers.values()]
				.filter(driver => {
					return !driver.isAvailableAtRequestedBlock(
						deliveryBlockTimeRange.startTime,
						deliveryBlockTimeRange.endTime,
						deliveryBlockId ? [deliveryBlockId] : [],
						teamId
					);
				})
				.map(driver => driver.id)
		);
	}, [drivers, deliveryBlockTimeRange.startTime, deliveryBlockTimeRange.endTime]);

	const unavailableVehicleIds = useMemo(() => {
		return unavailableIds(vehicles);
	}, [vehicles, deliveryBlockTimeRange.startTime, deliveryBlockTimeRange.endTime]);

	const unavailableTrailerIds = useMemo(() => {
		return unavailableIds(trailers);
	}, [trailers, deliveryBlockTimeRange.startTime, deliveryBlockTimeRange.endTime]);

	function unavailableIds(vehiclesOrTrailers) {
		return new Set(
			[...vehiclesOrTrailers.values()]
				.filter(vehicleOrTrailer => {
					return !deliveryBlocksStore.isAvailableAtRequestedBlock(
						vehicleOrTrailer,
						deliveryBlockTimeRange.startTime,
						deliveryBlockTimeRange.endTime,
						deliveryBlockId ? [deliveryBlockId] : []
					);
				})
				.map(vehicleOrTrailer => vehicleOrTrailer.id)
		);
	}

	return { unavailableDriverIds, unavailableVehicleIds, unavailableTrailerIds };
};

export default useUnavailableResources;
